module.exports = __webpack_public_path__ + "img/refer-popup.61a844cd.svg";